export enum EUserManagementCounterpartiesPageGetParams {
  Action = 'action',
}

export enum EUserManagementCounterpartiesPageGetParamsActionTypes {
  Create = 'create',
  Edit = 'edit',
}

export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}

export enum ECounterpartiesFilterFormKeys {
  GUID = 'guids',
  Name = 'names',
  Code = 'codes',
  HoldingName = 'holding_names',
  Ordering = 'ordering',
}
